import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFeederRotaryTable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 104.65,
	height: 100,
	viewBox: "0 0 104.65 100.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 2.33 0.0 L 102.33 0.0 M 52.33 0.0 L 52.33 100.0 M 62.33 40.0 A 50.0 20.0 0.0 1 1 42.33 40.0 M 36.33 37.0 L 42.33 40.0 L 36.33 43.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFeederRotaryTable;
